import { createResource } from '../../../utils/resource'

export default createResource('notification', {})